export default __webpack_public_path__ + "images/residential-icon@3x.png?60e7e65e499708854b062b522faa2a1e";